import type { ZodError } from "zod";

import { model1TemplateV1Schema, type Model1TemplateV1 } from "./templateContractV1";

export type ValidateModel1TemplateResult =
    | { ok: true; template: Model1TemplateV1 }
    | { ok: false; errors: string[] };

function flattenZodError(err: ZodError): string[] {
    return err.errors.map(e => {
        const path = e.path.length ? e.path.join(".") : "root";
        return `${path}: ${e.message}`;
    });
}

export function validateModel1Template(value: unknown): ValidateModel1TemplateResult {
    const parsed = model1TemplateV1Schema.safeParse(value);
    if (!parsed.success) {
        return { ok: false, errors: flattenZodError(parsed.error) };
    }
    return { ok: true, template: parsed.data };
}
